import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

type MultiselectProps = {
  selectionCount: number;
};

const textStylesSingle = css`
  max-width: 100%;
  height: 26px;
  background: white;
  border: 1px solid ${theme.colors.neutral40};
  border-radius: 15px;
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${theme.spacing(0.5, 0.75, 0.5, 1)};
  z-index: ${theme.zIndex.low};
`;

const textStylesMultiple = css`
  max-width: 70%;
  height: 26px;
  background: white;
  border: 1px solid ${theme.colors.neutral40};
  border-radius: 15px;
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${theme.spacing(0.5, 0.75, 0.5, 1)};
  z-index: ${theme.zIndex.low};
`;

export const MultiselectSelectionStyles = {
  textStyles: ({ selectionCount = 0 }: MultiselectProps) =>
    selectionCount > 1 ? textStylesMultiple : textStylesSingle,
  buttonStyles: css`
    color: ${theme.colors.neutral50};
    line-height: 0;
    margin-left: ${theme.spacing(1)};
    position: relative;
    transition: color 250ms ease-out;

    &::before {
      content: '';
      width: 24px;
      height: 24px;
      background: transparent;
      border: 2px solid transparent;
      border-radius: 50%;
      display: block;
      transition: border-color 250ms ease-out;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:focus {
      color: ${theme.colors.neutral60};
      outline: none;

      &::before {
        border-color: ${theme.colors.primary50};
      }
    }
  `,
  remainderStyles: css`
    margin: 0;
    padding-right: ${theme.spacing(3)};
  `,
};
